var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ConfigureComponentBase } from '../../../shared/configure-component-base';
import { Injectable } from '@angular/core';
import { ConfigureViewType } from '../designer/shared/configure-view-type';
var ViewTypeNameTranslateService = /** @class */ (function (_super) {
    __extends(ViewTypeNameTranslateService, _super);
    function ViewTypeNameTranslateService(injector) {
        return _super.call(this, injector) || this;
    }
    ViewTypeNameTranslateService.prototype.getViewTypeDisplayName = function (viewType) {
        switch (viewType) {
            case ConfigureViewType.Web:
                return this.lc('Web');
            case ConfigureViewType.Mobile:
                return this.lc('Mobile');
            case ConfigureViewType.Thumbnail:
                return this.lc('Thumbnail');
            case ConfigureViewType.PopView:
                return this.lc('PopView');
            default:
                throw new Error("ConfigureViewType:" + viewType + " not exist");
        }
    };
    ViewTypeNameTranslateService = __decorate([
        Injectable()
    ], ViewTypeNameTranslateService);
    return ViewTypeNameTranslateService;
}(ConfigureComponentBase));
export { ViewTypeNameTranslateService };
